import React, { useState, useRef, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

import {
  useOutsideAlerter,
  handleSidebarDrawerInit,
  sideBarList,
  downSideBarList,
  Languages,
  getCookies,
  getReadableDate,
  cmsSideBarList,
  casinoIcons,
} from "../../helper/utils";

import { useTheme } from "../../routes/private-route";
import { editProfile } from "../../redux/slices/profile/updateProfileSlice";
import { config } from "../../redux/slices/auth/configSlice";
import { getProfile } from "../../redux/slices/profile/fetchProfileSlice";
import { getAllNotification } from "../../redux/slices/notification/getAllNotificationSlice";
import { markSeen } from "../../redux/slices/notification/markSeenSlice";
import { markSeenAll } from "../../redux/slices/notification/markSeenAllSlice";
import UserProfile from "../../assets/images/UserProfile.png";
import Left from "../../assets/images/svgs/left.svg";
import Logo from "../../assets/images/logo-small.png";
import Ball from "../../assets/images/svgs/ball.svg";
import Profile from "../../assets/images/svgs/signup.png";
import login from "../../assets/images/svgs/login.svg";
import { ReactComponent as Notification } from "../../assets/images/svgs/notification.svg";
import Logout from "../../assets/images/svgs/logout.png";
import { ReactComponent as Search } from "../../assets/images/svgs/search.svg";
import casinoMain from "../../assets/images/svgs/casinoMain.svg";
import Home from "../../assets/images/casino-icons/home2.svg";
import { LogoutModal, MaintananceModel } from "../../components";

const HumburgerMenu = ({ menuOpen, setMenuOpen }) => {
  const { theme, toggleTheme, setGameSearch } = useTheme();
  const auth = getCookies("xcasino_token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const [query, setQuery] = useState("");
  const { t, i18n } = useTranslation();
  const {
    loading,
    error: profileError,
    data: profileData,
  } = useSelector((state) => state.getProfile);

  const configData = useSelector((state) => state.config.data);

  const [currentPage, setCurrentPage] = useState("");
  const [isToggled, setIsToggled] = useState(false);
  const [hoverProfile, setHoverProfile] = useState(false);
  const [hoverTheme, setHoverTheme] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [logoutModal, setLogoutModal] = useState(false);
  const [open, setOpen] = useState(menuOpen);
  const [notificationToggle, setNotificationToggle] = useState(false);
  const { innerWidth: width, innerHeight: height } = window;
  const [lang, setLang] = useState("en");

  const [showHeader, setShowHeader] = useState(false);
  const isTablet = width <= 992;

  useEffect(() => {
    if (!configData?.headerSettings) return;

    let hasMessage = false;
    let showValue = null;

    configData.headerSettings.forEach((setting) => {
      if (setting.api_key === "header_announcement") {
        hasMessage = true;
      }
      if (setting.api_key === "show_header_announcement") {
        showValue = setting.value.toLowerCase() === "true";
      }
    });

    if (hasMessage && showValue !== null) {
      setShowHeader(showValue);
    } else {
      setShowHeader(false);
    }
  }, [configData]);

  useOutsideAlerter(wrapperRef, open, setOpen);

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    if (isOnline && configData) {
      const domain = process.env.REACT_APP_FRONT_URL;
      const payload = { domain: domain };

      // dispatch(config(payload))
      //   .unwrap()
      //   .then((res) => {
      //     console.log("config data vpn", payload, res);
      //   })
      //   .catch((error) => {
      //     console.error("Failed :", error);
      //   });
    } else {
    }
  }, [isOnline]);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };
    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Cleanup
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("unload", handleSignout);
    return () => {
      window.removeEventListener("unload", handleSignout);
    };
  }, []);

  useEffect(() => {
    // if (query === "") return;

    const timer = setTimeout(() => {
      setGameSearch(query);
    }, 2000);

    return () => clearTimeout(timer);
  }, [query]);

  const handleSettings = (field, lng) => {
    let payload;
    // if (field == "color_mode") {
    //   payload = {
    //     id: profileData.user._id,
    //     color_mode: theme == "Dark" ? "Light" : "Dark",
    //   };
    // }
    if (profileData) {
      if (field == "notification") {
        payload = {
          id: profileData?.user?._id,
          notification: !notificationToggle,
        };
      } else if (field == "language") {
        payload = {
          id: profileData?.user?._id,
          language: lng,
        };
      }

      dispatch(editProfile(payload))
        .unwrap()
        .then((res) => {
          handleConfig(res.user.parent_user_id);
          getProfileData();
        })
        .catch((error) => {
          toast.error(error.message);
          console.error("Failed :", error);
        });
    }
  };

  useEffect(() => {
    if (width <= 990) {
      setMenuOpen(!open);
    } else {
      setMenuOpen(open);
    }
  }, [open]);

  useEffect(() => {
    console.log(166);
    getProfileData();
  }, []);

  useEffect(() => {
    if (!profileData) {
      getProfileData();
    } else {
      // toggleTheme(
      //   profileData?.user?.color_mode ? profileData?.user?.color_mode : "Dark"
      // );
      setNotificationToggle(profileData?.user?.notification);
      setLang(profileData?.user?.language);
      i18n.changeLanguage(profileData?.user?.language);
    }
  }, [profileData, auth]);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");

    if (savedTheme) {
      toggleTheme(savedTheme); // Use stored theme
    } else if (configData?.color_mode) {
      toggleTheme(configData?.color_mode); // Fallback to config if no saved theme
      localStorage.setItem("theme", configData?.color_mode);
    }
  }, [configData]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLang(lng);

    handleSettings("language", lng);
  };

  const handleDrawerOpen = (event) => {
    event.preventDefault();
    setOpen(!open);
    handleSidebarDrawerInit();
  };

  const handleSidebarClick = (e) => {
    console.log(233, e.url)
    navigate(`/${e.url}`);
    setCurrentPage(e.label);
    // setMenuOpen(!menuOpen)
    setHoverProfile(!hoverProfile);
  };

  const handleSignout = () => {
    setLogoutModal(true);
  };

  const getProfileData = () => {
    if (auth) {
      dispatch(getProfile())
        .unwrap()
        .then((res) => {
          handleConfig(res?.user?.parent_user_id, res?.user._id);
        })
        .catch((error) => {
          console.error("Failed :", error);
        });
    }
  };

  const handleConfig = (id, userId) => {
    const domain = process.env.REACT_APP_FRONT_URL;
    const vpnToken = localStorage.getItem("vpnToken");
    const payload = { parentId: id, userId: userId, vpnToken };

    console.log("config call");

    dispatch(config(payload))
      .unwrap()
      .then((res) => {
        console.log("config data vpn", payload, res);
      })
      .catch((error) => {
        console.error("Failed :", error);
      });
  };

  useEffect(() => {
    if (auth && profileData?.user?.notification) {
      handleGetAllNotification();
    }
  }, [auth, profileData]);

  const handleGetAllNotification = () => {
    dispatch(getAllNotification())
      .unwrap()
      .then((res) => {
        setNotifications(res.notifications);
      })
      .catch((error) => {
        console.error("Failed :", error);
      });
  };

  const handleMarkSeen = (all, id) => {
    if (all) {
      dispatch(markSeenAll())
        .unwrap()
        .then((res) => {})
        .catch((error) => {
          console.error("Failed :", error);
        });
    } else {
      dispatch(markSeen({ _id: id }))
        .unwrap()
        .then((res) => {})
        .catch((error) => {
          console.error("Failed :", error);
        });
    }
  };

  function openNotification() {
    navigate("/notification");
    // document.getElementById("notificationPanel").classList.add("active");
  }

  function closeNotification() {
    // document.getElementById("notificationPanel").classList.remove("active");
  }

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".app-navbar-item")) {
        setHoverProfile(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    const isSidebarOpen =
      document.getElementsByClassName("sidebar open").length > 0;
    if (isSidebarOpen && isMobile) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isToggled]);

  return (
    <div>
      <div id="wrapper" className={`wrapper ${isToggled ? "toggled" : ""}`}>
        <LogoutModal open={logoutModal} setOpen={setLogoutModal} />
        <MaintananceModel open={configData?.maintenance_mode === "true"} />
        {window.innerWidth > 768 && (
          <aside
            id="sidebar-wrapper"
            style={{
              top: showHeader ? 20 : 0,
            }}
          >
            <div className="sidebar-brand">
              <img
                src={configData?.website_logo ? configData?.website_logo : Logo}
                alt=""
                className={`cursor-pointer`}
                onClick={() => {
                  navigate("/");
                }}
                style={{
                  maxHeight: "50px",
                  width: `${
                    isToggled
                      ? isTablet
                        ? "50%"
                        : "100%"
                      : isTablet
                      ? "100%"
                      : "auto"
                  }`,
                }}
              />
            </div>
            <ul className="sidebar-nav">
              {/* <hr /> */}
              <li
                className={
                  // item.label == currentPage
                  //   ? `active side-link`
                  `ps-1 cursor-pointer  `
                }
                onClick={() => {
                  navigate("/");
                }}
              >
                <div className="d-flex align-items-center">
                  <img
                    src={Home}
                    alt="icon"
                    width={22}
                    height={22}
                    className={`svg-icon home-icon ${
                      isToggled && !isTablet && "me-3 home-icon-toggled"
                    } ${isTablet && !isToggled ? "me-3 ms-1" : ""}`}
                  />

                  <span className="ms-1 me-2 fs-12 text-uppercase">Home</span>
                </div>
              </li>
              <li
                className={
                  // item.label == currentPage
                  //   ? `active side-link`
                  `cursor-pointer `
                }
                onClick={() => {
                  // handleSidebarClick(item);
                }}
              >
                <div
                  className="accordion  custom-accordian-drop my-1 "
                  style={{}}
                  id="accordionExampleCasino"
                >
                  <div className="accordion-item bg-transparent w-100">
                    <p
                      className="accordion-header accordion-header-side "
                      id="headingCasino"
                    >
                      <button
                        className="accordion-button py-0 fs-14 text-white 
                       px-0 side-link-dropdown"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseCasino"
                        aria-expanded="true"
                        aria-controls="collapseCasino"
                      >
                        <div className="fs-14 ps-1">
                          <span
                            className={`svg-icon svg-icon-2 me-2 ${
                              isToggled && !isTablet && "ms-2 me-5"
                            } ${!isToggled && isTablet && "me-5 ms-1"} `}
                          >
                            <img
                              src={casinoMain}
                              alt="icon"
                              width={22}
                              height={22}
                              className="svg-icon"
                            />
                          </span>
                          <span className="ms-1 me-2 fs-12 text-uppercase">
                            Casino
                          </span>
                        </div>
                      </button>
                    </p>
                    <div
                      id="collapseCasino"
                      className=" accordion-collapse collapse show bg-transparent"
                      aria-labelledby="headingCasino"
                      data-bs-parent="#accordionExampleCasino"
                      style={{ background: "transparent !important" }}
                    >
                      <div
                        className="custom-accordion-body fs-14 "
                        style={{
                          backgroundColor: "transparent !important",
                          width: "max-content",
                        }}
                      >
                        <div
                          className={`bg-transparent p-1  ${
                            isToggled && "ms-0"
                          } `}
                          style={{ background: "transparent !important" }}
                        >
                          {configData?.casinoCategories?.map((item, index) => {
                            const toCamelCase = (str) => {
                              return str
                                .toLowerCase()
                                .split(" ")
                                .map((word, i) =>
                                  i === 0
                                    ? word
                                    : word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                )
                                .join("");
                            };

                            // Fallback formatter: "cuda" → "Cuda"
                            const formatDisplayName = (str) => {
                              return str
                                .toLowerCase()
                                .replace(/\b\w/g, (char) => char.toUpperCase());
                            };
                            return (
                              <div
                                key={index}
                                className={`d-flex align-items-center my-2 cms-section cursor-pointer fs-11 text-uppercase ${
                                  item.name === currentPage
                                    ? "active side-link"
                                    : ""
                                } ${isToggled && "ps-0"}`}
                                onClick={() => {
                                  console.log(503, item.name)
                                  // setGameSearch(item.name)
                                  navigate(
                                    `/casino-games/${encodeURIComponent(
                                      item.name
                                    )}`
                                  );
                                  setCurrentPage(item.name);
                                }}
                              >
                                <span className="svg-icon svg-icon-2">
                                  {casinoIcons[index]?.img || null}
                                </span>

                                <span className="ms-2 fs-12">
                                  {t(`CasinoGames.${toCamelCase(item.name)}`) ||
                                    formatDisplayName(item.name)}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div>
                  <span className="svg-icon svg-icon-2 ">
                    <img src={Ball} alt="" />
                  </span>

                  <span className=" ms-3 fs-14">Cricket</span>
                </div> */}
              </li>
              {!isToggled && <hr />}
              {/* {sideBarList?.map((item, index) => (
                <li
                  className={
                    item.label == currentPage
                      ? `active side-link`
                      : `` + `cursor-pointer `
                  }
                  key={index}
                  onClick={() => {
                    handleSidebarClick(item);
                  }}
                >
                  <div>
                    <span className="svg-icon svg-icon-2  ">{item.img}</span>

                    <span className=" ms-4 fs-14 name-wrapper">
                      {t(`Sidebar.${item.name}`)}
                    </span>
                  </div>
                </li>
              ))} */}
              {/* <hr /> */}
              {downSideBarList?.map((item, index) => (
                <li key={index} className={`${isToggled && "d-none"}`}>
                  <div
                    className="accordion  custom-accordian-drop my-1 "
                    style={{}}
                    id="accordionExample"
                  >
                    <div className="accordion-item bg-transparent w-100">
                      <p
                        className="accordion-header accordion-header-side "
                        id="headingSecond"
                      >
                        <button
                          className="accordion-button  py-0 fs-14 text-white 
                       px-0 side-link-dropdown  "
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSecond"
                          aria-expanded="true"
                          aria-controls="collapseSecond"
                        >
                          <div className="fs-14 ps-1">
                            <span
                              className={`svg-icon svg-icon-2 me-3  ${
                                isTablet && !isToggled && "me-5 ms-1"
                              } `}
                            >
                              {item.img}
                            </span>
                            <span
                              className={`ms-1 me-2 fs-12 fs-12 text-uppercase`}
                            >
                              {t("Sidebar.others")}
                            </span>
                          </div>
                        </button>
                      </p>
                      <div
                        id="collapseSecond"
                        className="accordion-collapse collapse show bg-transparent"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                        style={{ background: "transparent !important" }}
                      >
                        <div
                          className="custom-accordion-body fs-14 "
                          style={{
                            backgroundColor: "transparent !important",
                          }}
                        >
                          <div
                            className={`
                            bg-transparent p-1`} //  ${!profileData ? "cursor-none opacity-50" : ""}
                            style={{ background: "transparent !important" }}
                          >
                            {/* <span className="bg-transparent mb-0 fs-14 fw-bold ">
                              {t("Sidebar.modes")}
                            </span>

                            <div className="d-flex px-0 mx-0 gap-2">
                              <div className="form-check px-0 mx-0 ms-2 d-flex align-items-center">
                                <input
                                  className="custom-checkbox"
                                  type="radio"
                                  name="flexRadioDefault"
                                  disabled={!profileData}
                                  id="flexRadioDefault1"
                                  checked={theme == "Dark" ? true : false}
                                  onChange={() => {
                                    console.log(theme);

                                    handleSettings("color_mode");
                                    toggleTheme("Dark");
                                  }}
                                />
                                <label
                                  className="form-check-label fs-14"
                                  htmlFor="flexRadioDefault1"
                                >
                                  {t("Common.dark")}
                                </label>
                              </div>
                              <div className="form-check px-0 mx-0 d-flex align-items-center">
                                <input
                                  className="custom-checkbox"
                                  type="radio"
                                  name="flexRadioDefault"
                                  disabled={!profileData}
                                  id="flexRadioDefault2"
                                  checked={theme == "Light" ? true : false}
                                  onChange={() => {
                                    handleSettings("color_mode");
                                    toggleTheme("Light");
                                  }}
                                />
                                <label
                                  className="form-check-label fs-14"
                                  htmlFor="flexRadioDefault2"
                                >
                                  {t("Common.light")}
                                </label>
                              </div>
                            </div> */}

                            <span className="d-flex bg-transparent mb-0 fs-12 text-uppercase ">
                              <label for="flexSwitchCheckChecked">
                                {t("Sidebar.notification")}
                              </label>
                              <div className="form-check form-switch mt-2">
                                <input
                                  className="form-check-input form-custom-switch ms-1"
                                  type="checkbox"
                                  data-onstyle="outline-secondary"
                                  checked={notificationToggle}
                                  disabled={!profileData}
                                  id="flexSwitchCheckChecked"
                                  onChange={(e) => {
                                    setNotificationToggle(!notificationToggle);
                                    handleSettings("notification");
                                  }}
                                />
                              </div>
                            </span>
                            <div style={{ width: "max-content" }}>
                             
                              {cmsSideBarList.map((item, index) => (
                                <div
                                  key={index}
                                  className={
                                    item.label == currentPage
                                      ? `active side-link`
                                      : `` +
                                        `d-flex align-items-center my-2 cms-section cursor-pointer fs-11 text-uppercase `
                                  }
                                  onClick={() => {
                                    handleSidebarClick(item);
                                  }}
                                >
                                  <span className="svg-icon svg-icon-2 me-2">
                                    {item.img}
                                  </span>
                                  <span className="bg-transparent mb-0 fs-12 text-uppercase ">
                                    {/* {t(`Sidebar.${item.name}`)}- */}
                                    
                                    {t("Sidebar." + item.name)}
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ))}

              {/* <li>
                <div
                  className="accordion  custom-accordian-drop my-1 "
                  style={{}}
                  id="accordionExampleCms"
                >
                  <div className="accordion-item bg-transparent w-100">
                    <p
                      className="accordion-header accordion-header-side "
                      id="headingCms"
                    >
                      <button
                        className="accordion-button py-0 fs-14 text-white 
                       px-0 side-link-dropdown position-relative"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseCMS"
                        aria-expanded="true"
                        aria-controls="collapseCMS"
                      >
                        <div className="fs-14 ps-1">
                          <span className="svg-icon svg-icon-2 me-3">
                            <img
                              src={Setting}
                              alt="icon"
                              width={22}
                              height={22}
                              className="svg-icon"
                            />
                          </span>
                          <span className="ms-1 me-2 fs-14">CMS</span>
                        </div>
                      </button>
                    </p>
                    <div
                      id="collapseCMS"
                      className=" accordion-collapse collapse show bg-transparent"
                      aria-labelledby="headingCms"
                      data-bs-parent="#accordionExampleCms"
                      style={{ background: "transparent !important" }}
                    >
                      <div
                        className="custom-accordion-body fs-14 "
                        style={{
                          backgroundColor: "transparent !important",
                          width: "max-content",
                        }}
                      >
                        <div
                          className="bg-transparent p-1 ms-2"
                          style={{ background: "transparent !important" }}
                        >
                          {cmsSideBarList.map((item, index) => (
                            <div
                              key={index}
                              className={
                                // item.label == currentPage
                                //   ? `active side-link`
                                `cursor-pointer cms-section`
                              }
                              onClick={() => {
                                handleSidebarClick(item);
                              }}
                            >
                              <span className="bg-transparent mb-0 fs-14 fw-bold ">
                                {item.label}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li> */}
            </ul>
          </aside>
        )}

        {window.innerWidth <= 768 && (
          <div className="sidebar-layout">
            {/* <button
           className="hamburger"
           onClick={() => setIsToggled(!isToggled)}
           aria-label="Toggle sidebar"
         >
           ☰
         </button> */}

            {/* <div
              className=""
              onClick={() => setIsToggled(!isToggled)}
              aria-label="Toggle sidebar"
            >
              <span className="hamburger svg-icon svg-icon-2 text-center">
                <img
                  src={Left}
                  style={{
                    transform: isToggled ? "rotate(90deg)" : "rotate(270deg)",
                  }}
                />
              </span>

              <a href="#" className="navbar-brand" id="sidebar-toggle">
                <i className="fa fa-bars"></i>
              </a>
            </div> */}

            <div className={`sidebar ${isToggled ? "open" : ""}`}>
              {isToggled && (
                <div className="humburger-mobile-icon">
                  <div
                    className="sidebar-overlay"
                    onClick={() => setIsToggled(!isToggled)}
                  >
                    <div className={`hamburger1 open`}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              )}
              <div className="sidebar-content">
                <div className="sidebar-brand">
                  <img
                    src={
                      configData?.website_logo ? configData?.website_logo : Logo
                    }
                    alt={""}
                    className="cursor-pointer"
                    onClick={() => {
                      navigate("/");
                      setIsToggled(false);
                    }}
                    style={{ maxHeight: "50px" }}
                  />
                </div>
                <ul className="sidebar-nav">
                  <hr />
                  <li
                    className={
                      // item.label == currentPage
                      //   ? `active side-link`
                      `ps-1 cursor-pointer  `
                    }
                    onClick={() => {
                      setIsToggled(false);
                      navigate("/");
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <img
                        src={Home}
                        alt="icon"
                        width={22}
                        height={22}
                        className={`svg-icon home-icon ${
                          isToggled && !isTablet && "me-3 home-icon-toggled"
                        } ${isTablet && !isToggled ? "me-3 ms-1" : ""}`}
                      />

                      <span className="ms-1 me-2 fs-12 text-uppercase">
                        Home
                      </span>
                    </div>
                  </li>
                  <li
                    className={
                      // item.label == currentPage
                      //   ? `active side-link`
                      `cursor-pointer `
                    }
                    onClick={() => {
                      // handleSidebarClick(item);
                    }}
                  >
                    <div className="accordion-item bg-transparent w-100">
                      <p
                        className="accordion-header accordion-header-side "
                        id="headingCasino"
                      >
                        <button
                          className="accordion-button py-0 fs-14 text-white 
                       px-0 side-link-dropdown"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseCasino"
                          aria-expanded="true"
                          aria-controls="collapseCasino"
                        >
                          <div className="fs-14 ps-1">
                            <span className="svg-icon svg-icon-2 me-2">
                              <img
                                src={casinoMain}
                                alt="icon"
                                width={22}
                                height={22}
                                className={`svg-icon`}
                              />
                            </span>
                            <span className="ms-1 me-2 fs-14">Casino</span>
                          </div>
                        </button>
                      </p>
                      <div
                        id="collapseCasino"
                        className=" accordion-collapse collapse show bg-transparent"
                        aria-labelledby="headingCasino"
                        data-bs-parent="#accordionExampleCasino"
                        style={{ background: "transparent !important" }}
                      >
                        <div
                          className="custom-accordion-body fs-14 "
                          style={{
                            backgroundColor: "transparent !important",
                            width: "max-content",
                          }}
                        >
                          <div
                            className={`bg-transparent p-1  ${
                              isToggled && "ms-0"
                            } `}
                            style={{ background: "transparent !important" }}
                          >
                            {configData?.casinoCategories?.map(
                              (item, index) => {
                                const toCamelCase = (str) => {
                                  return str
                                    .toLowerCase()
                                    .split(" ")
                                    .map((word, i) =>
                                      i === 0
                                        ? word
                                        : word.charAt(0).toUpperCase() +
                                          word.slice(1)
                                    )
                                    .join("");
                                };

                                // Fallback formatter: "cuda" → "Cuda"
                                const formatDisplayName = (str) => {
                                  return str
                                    .toLowerCase()
                                    .replace(/\b\w/g, (char) =>
                                      char.toUpperCase()
                                    );
                                };
                                return (
                                  <div
                                    key={index}
                                    className={`d-flex align-items-center my-2 cms-section cursor-pointer ${
                                      item.name === currentPage
                                        ? "active side-link"
                                        : ""
                                    } ${isToggled && "ps-0"}`}
                                    onClick={() => {
                                      console.log(972, item.name)
                                      navigate(
                                        `/casino-games/${encodeURIComponent(
                                          item.name
                                        )}`
                                      );
                                      setCurrentPage(item.name);
                                      setIsToggled(false);
                                    }}
                                  >
                                    <span className="svg-icon svg-icon-2">
                                      {/* <img src={item.image_url} alt="" /> */}
                                      {casinoIcons[index]?.img || null}
                                    </span>
                                    <span className="ms-2 fs-14">
                                      {t(
                                        `CasinoGames.${toCamelCase(item.name)}`
                                      ) || formatDisplayName(item.name)}
                                    </span>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  {/* <hr /> */}
                  {/* {sideBarList?.map((item, index) => (
                    <li
                      className={
                        item.label == currentPage
                          ? `active side-link`
                          : `` + `cursor-pointer `
                      }
                      key={index}
                      onClick={() => {
                        handleSidebarClick(item);
                        setMenuOpen(false);
                      }}
                    >
                      <div>
                        <span className="svg-icon svg-icon-2  ">
                          {item.img}
                        </span>

                        <span className=" ms-4 fs-14 name-wrapper">
                          {t(`Sidebar.${item.name}`)}
                        </span>
                      </div>
                    </li>
                  ))} */}
                  {/* <hr /> */}
                  {downSideBarList?.map((item, index) => (
                    <li key={index}>
                      <div
                        className="accordion  custom-accordian-drop my-1 "
                        style={{}}
                        id="accordionExample"
                      >
                        <div className="accordion-item bg-transparent w-100">
                          <p
                            className="accordion-header accordion-header-side "
                            id="headingSecond"
                          >
                            <button
                              className="accordion-button  py-0 fs-14 text-white 
                       px-0 side-link-dropdown  "
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseSecond"
                              aria-expanded="true"
                              aria-controls="collapseSecond"
                            >
                              <div className="fs-14 ps-1">
                                <span className="svg-icon svg-icon-2 me-3">
                                  {item.img}
                                </span>
                                <span className="ms-1 me-2 fs-14">
                                  {t("Sidebar.setting")}
                                </span>
                              </div>
                            </button>
                          </p>
                          <div
                            id="collapseSecond"
                            className="accordion-collapse collapse show bg-transparent"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                            style={{ background: "transparent !important" }}
                          >
                            <div
                              className="custom-accordion-body fs-14 "
                              style={{
                                backgroundColor: "transparent !important",
                              }}
                            >
                              <div
                                className="bg-transparent p-1 "
                                style={{ background: "transparent !important" }}
                              >
                                <span className="d-flex bg-transparent mb-0 fs-14 fw-bold gap-2">
                                  {t("Sidebar.notification")}
                                  <div className="form-check form-switch mt-1">
                                    <input
                                      className="form-check-input form-custom-switch ms-1 mt-1"
                                      type="checkbox"
                                      checked={notificationToggle}
                                      disabled={!profileData}
                                      id="flexSwitchCheckChecked"
                                      onChange={(e) => {
                                        setNotificationToggle(
                                          !notificationToggle
                                        );
                                        handleSettings("notification");
                                        setIsToggled(!isToggled);
                                      }}
                                    />
                                  </div>
                                </span>
                                <div style={{ width: "max-content" }}>
                               
                                  {cmsSideBarList.map((item, index) => (
                                    <div
                                      key={index}
                                      className={
                                        item.label == currentPage
                                          ? `active side-link`
                                          : `` +
                                            `d-flex align-items-center my-2 cms-section cursor-pointer  ps-0`
                                      }
                                      onClick={() => {
                                        handleSidebarClick(item);
                                        setIsToggled(false);
                                      }}
                                    >
                                      <span className="svg-icon svg-icon-2 ">
                                        {item.img}
                                      </span>
                                      <span className="bg-transparent mb-0 fs-14 fw-bold ">
                                        {t("Sidebar." + item.name)}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {isToggled && (
              <div className="backdrop" onClick={() => setIsToggled(false)} />
            )}
          </div>
        )}

        <div
          id="navbar-wrapper"
          style={{
            top: showHeader ? 20 : 0,
          }}
        >
          {/* {!profileData?.user?.isDemoUser && (
            <h4 className="w-100 text-center text-white">
              <span className="m-auto">Yor are logged in as a Demo user. </span>
            </h4>
          )} */}
          {/* {window.innerWidth >= 768 && ( */}
          <div
            className=""
            onClick={(e) => {
              // e.preventDefault();
              setIsToggled((prevState) => !prevState);
              handleDrawerOpen(e);
            }}
          >
            <span className="svg-icon svg-icon-2 sidebar-arrow text-center d-flex justify-content-center align-items-center">
              {/* <img
                src={Left}
                className="w-50"
                style={{
                  transform: open ? "rotate(0deg)" : "rotate(180deg)",
                }}
              /> */}
              {window.innerWidth < 768 ? (
                <div className={`hamburger1 `}>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              ) : (
                <div className={`hamburger1 ${open ? "" : "open"}`}>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              )}
            </span>
          </div>
          {/* )} */}
          <nav className="navbar navbar-inverse d-block">
            {window.innerWidth < 768 ? (
              <div className="d-flex flex-column px-3 pt-2 gap-3">
                {/* Profile + Theme Switch */}
                
                <div className="d-flex justify-content-end align-items-center gap-2">

                <div
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  <img
                    src={Home}
                    alt="icon"
                    width={22}
                    height={22}
                    className={`svg-icon home-icon ${
                      isToggled && !isTablet && "me-1 home-icon-toggled"
                    } ${isTablet && !isToggled ? "me-1 ms-1" : ""}`}
                  />
                </div>


                  {/* Theme Toggle */}
                  <label className="theme-toggle mb-0">
                    <input
                      type="checkbox"
                      checked={theme === "Light"}
                      // disabled={!profileData}
                      onChange={() => {
                        handleSettings("color_mode");
                        toggleTheme(theme === "Dark" ? "Light" : "Dark");
                      }}
                    />
                    <span className="slider">
                      <span className="icon sun">☀️</span>
                      <span className="icon moon">🌙</span>
                    </span>
                  </label>

                  {profileData?.user?.notification && (
                    <div
                      className="app-navbar-item ms-1 ms-md-3 align-self-center"
                      onClick={() => {
                        openNotification();
                      }}
                    >
                      <Notification className="svg-icon-component" />
                    </div>
                  )}

                  <div className="notification-panel" id="notificationPanel">
                    <div className="notification-header">
                      <h2 className="fw-bold hero-heading">Notifications</h2>
                      <button
                        className="close-btn"
                        onClick={() => {
                          closeNotification();
                        }}
                      >
                        ×
                      </button>
                    </div>
                    <div className="notification-content">
                      {notifications.map((itm, index) => (
                        <div key={index} className="notification-item ">
                          <span className="fs-16 text-white">
                            <span className="fw-semibold">{itm.title}</span>
                            <br />
                            <span className="">{itm.description}</span>
                          </span>
                          <div className="d-flex justify-content-between">
                            <span className="w-100 fs-12 text-white opacity-50">
                              {getReadableDate(itm.createdAt)}
                            </span>
                            <span
                              className="w-100 fs-12 text-purple cursor-pointer text-end"
                              onClick={() => {
                                handleMarkSeen(false, itm.userNotificationId);
                              }}
                            >
                              Mark as read
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {profileData ? (
                    <div className="app-navbar-item ms-md-3 align-self-center">
                      <div
                        className="cursor-pointer symbol symbol-30px symbol-md-40px"
                        // onMouseOver={() => {
                        //   setHoverProfile(true);
                        //   setHoverTheme(false);
                        // }}
                        onClick={() => {
                          setHoverProfile((prev) => !prev); // toggle on click
                          setHoverTheme(false);
                        }}
                      >
                        <span
                          className="svg-icon svg-icon-2 text-capitalize"
                          style={{
                            borderRadius: "50%",
                            width: "50px",
                            height: "40px",
                            padding: "7px 15px",
                            color: "white",
                            background: "var(--secondary-accent)",
                          }}
                        >
                          {profileData?.user?.name?.charAt(0)}
                        </span>
                        {/* <img
                        src={profileData?.user?.profile_pic || UserProfile}
                        className="svg-icon svg-icon-2"
                      /> */}
                      </div>

                      {hoverProfile && (
                        <div
                          className="menu menu-sub menu-sub-dropdown menu-gray-800 py-3 pb-2 mt-3 fs-6"
                          // onMouseOver={() => {
                          //   setHoverProfile(true);
                          // }}
                          // onMouseOut={() => {
                          //   setHoverProfile(false);
                          // }}
                          // onClick={(e) => {
                          //   e.nativeEvent.stopImmediatePropagation();
                          // }}
                          onClick={(e) => {
                            e.nativeEvent.stopImmediatePropagation();
                          }}
                          style={{ zIndex: 999 }}
                        >
                          <div className="menu-item px-3 cursor-none">
                            <div className="menu-content d-flex align-items-center ">
                              <div className="d-flex align-items-center mb-3 gap-2">
                                <div className="symbol symbol-50px me-1">
                                  <img
                                    src={
                                      profileData?.user?.profile_pic ||
                                      UserProfile
                                    }
                                    alt="User"
                                    className="rounded-circle object-fit-cover"
                                  />
                                </div>
                                <div className="menu-section">
                                  <div className="fw-bold">
                                    {profileData?.user?.username}
                                  </div>
                                  <div className="fs-12">
                                    {profileData?.user?.mobile}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {sideBarList.map((item, idx) => (
                            <div key={idx}>
                              <div className="separator my-1"></div>

                              <div
                                className={`menu-item px-2 py-1 mx-2 ${
                                  item.label === currentPage
                                    ? "active side-link"
                                    : ""
                                }`}
                                onClick={() => {
                                  handleSidebarClick(item);
                                }}
                              >
                                <span className="svg-icon svg-icon-2  ">
                                  {item.img}
                                </span>
                                <span className="menu-link fs-14 px-2">
                                  {item.label}
                                </span>
                              </div>
                            </div>
                          ))}

                          <div className="separator my-1"></div>

                          <div
                            className="menu-item-logout px-2 py-1 mx-2"
                            onClick={() => {
                              console.log("signout");
                              handleSignout();
                            }}
                          >
                            <span className="svg-icon svg-icon-2  ">
                              <img
                                src={Logout}
                                alt="icon"
                                width={22}
                                height={22}
                                className="svg-icon"
                              />
                            </span>
                            <span className="menu-link fs-14 px-2">Logout</span>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      <div className="app-navbar-item ms-1 ms-md-3 align-self-center">
                        <span
                          className="box-purple text-white-btn fs-14 py-2 px-2 align-self-center cursor-pointer"
                          onClick={() => {
                            navigate("/signin-username");
                          }}
                        >
                          <img src={login} alt="icon" className="svg-icon" />{" "}
                          {t("SignUpPage.login")}
                        </span>
                      </div>
                      <div className="app-navbar-item ms-1 ms-md-3 align-self-center">
                        <span
                          className="box-purple text-white-btn  fs-14 py-2 px-2 align-self-center cursor-pointer"
                          onClick={() => {
                            navigate("/signup");
                          }}
                        >
                          <img src={Profile} alt="icon" className="svg-icon" />{" "}
                          {t("SignUpPage.signUp")}
                        </span>
                      </div>
                    </>
                  )}
                </div>

                {/* Search */}
                <div className="search-container d-flex align-items-center gap-2">
                  <Search className="svg-icon-component ms-2" />

                  <input
                    type="text"
                    placeholder={`${t("Sidebar.searchEvent")} ${t(
                      "Sidebar.3letter"
                    )}`}
                    onChange={(e) => setQuery(e.target.value)}
                    className="form-control"
                  />
                </div>

                {/* Language + Balance */}
                {}
                <div className="d-flex justify-content-between align-items-center">
                  <div className="app-navbar-item ms-1 ms-md-3 align-self-center  ">
                    <select
                      name={"language"}
                      value={lang}
                      aria-label={`Language`}
                      data-control="select2"
                      data-placeholder={`Select`}
                      className="form-select select-lng p-1 ps-2 cursor-pointer language-input"
                      onChange={(e) => {
                        changeLanguage(e.target.value);
                      }}
                    >
                      {Languages?.map((item, index) => (
                        <option
                          key={index}
                          value={item.value}
                          onClick={(e) => {}}
                        >
                          <b>{item.label}</b>
                        </option>
                      ))}
                    </select>
                  </div>

                  {profileData?.user && (
                    <div className="d-flex d-sm-flex d-md-flex d-lg-block d-xl-block  app-navbar-item ms-1 py-1 px-2 border-grey rounded-4 text-white fw-semibold fs-14 ms-md-3 align-self-center">
                      <span className="fs-10 align-self-center me-1 d-block ">
                        {t("Sidebar.balance")}:{" "}
                        {/* {profileData?.user?.usable_coin_balance?.toFixed(2)} */}
                        {(Number(profileData?.user?.usable_coin_balance) - Number(profileData?.user?.current_liability)).toFixed(2)}
                       
                      </span>
                      {/* <br /> */}
                      {/* <span className="fs-10 align-self-center d-block me-1">
                        Exposure: {profileData?.user?.current_liability}
                      </span> */}
                      {/* <br /> */}
                      <span className="fs-10 align-self-center d-block me-1">
                        {t("Sidebar.bonus")}:{" "}
                        {profileData?.user?.bonus_wallet?.toFixed(2)}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div
                className=" d-flex flex-wrap justify-content-between "
                style={{
                  width: `${
                    menuOpen ? window.innerWidth - 270 : window.innerWidth - 80
                  }px`,
                }}
              >
                <div className="d-flex ms-5">
                  <div className="search-container px-2 sidebar-search-input">
                    <Search className="svg-icon-component " />
                    <input
                      type="text"
                      placeholder={`${t("Sidebar.searchEvent")} ${t(
                        "Sidebar.3letter"
                      )}`}
                      onChange={(e) => {
                        setQuery(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="app-navbar d-flex cursor-pointer flex-shrink-0 me-3 ">
                  <div className="d-flex mt-2 mt-xs-2 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
                    <div className="theme-switch-wrapper d-flex align-items-center gap-2">
                      {/* <span
                      className={`theme-label ${
                        theme === "Dark" ? "active" : ""
                      }`}
                    >
                      🌙 {t("Common.dark")}
                    </span> */}
                      <label className="theme-toggle">
                        <input
                          type="checkbox"
                          checked={theme === "Light"}
                          // disabled={!profileData}
                          onChange={() => {
                            handleSettings("color_mode");
                            toggleTheme(theme === "Dark" ? "Light" : "Dark");
                          }}
                        />
                        <span className="slider">
                          <span className="icon sun">☀️</span>
                          <span className="icon moon">🌙</span>
                        </span>
                      </label>
                      {/* <span
                      className={`theme-label ${
                        theme === "Light" ? "active" : ""
                      }`}
                    >
                      ☀️ {t("Common.light")}
                    </span> */}
                    </div>

                    <div className="app-navbar-item ms-1 ms-md-3 align-self-center  ">
                      <select
                        name={"language"}
                        value={lang}
                        aria-label={`Language`}
                        data-control="select2"
                        data-placeholder={`Select`}
                        className="form-select select-lng p-1 ps-2 cursor-pointer language-input"
                        onChange={(e) => {
                          changeLanguage(e.target.value);
                        }}
                      >
                        {Languages?.map((item, index) => (
                          <option
                            key={index}
                            value={item.value}
                            onClick={(e) => {}}
                          >
                            <b>{item.label}</b>
                          </option>
                        ))}
                      </select>
                    </div>

                    {profileData?.user && (
                      <div className="d-flex d-sm-flex d-md-flex d-lg-block d-xl-block  app-navbar-item ms-1 py-1 px-2 border-grey rounded-4 text-white fw-semibold fs-14 ms-md-3 align-self-center">
                        <span className="fs-10 align-self-center me-1 d-block">
                          {t("Sidebar.balance")} :{" "}
                          {/* {profileData?.user?.usable_coin_balance?.toFixed(2)} */}
                          {(Number(profileData?.user?.usable_coin_balance) - Number(profileData?.user?.current_liability)).toFixed(2)}
                        </span>
                        {/* <br /> */}
                        {/* <span className="fs-10 align-self-center d-block me-1 ">
                          Exposure: {profileData?.user?.current_liability}
                        </span> */}
                        {/* <br /> */}
                        <span className="fs-10 align-self-center d-block me-1">
                          {t("Sidebar.bonus")}:{" "}
                          {profileData?.user?.bonus_wallet?.toFixed(2)}
                        </span>
                      </div>
                    )}

                    {profileData?.user?.notification && (
                      <div
                        className="app-navbar-item ms-1 ms-md-3 align-self-center"
                        onClick={() => {
                          openNotification();
                        }}
                      >
                        <Notification className="svg-icon-component" />
                      </div>
                    )}
                  </div>

                  <div className="notification-panel" id="notificationPanel">
                    <div className="notification-header">
                      <h2 className="fw-bold hero-heading">Notifications</h2>
                      <button
                        className="close-btn"
                        onClick={() => {
                          closeNotification();
                        }}
                      >
                        ×
                      </button>
                    </div>
                    <div className="notification-content">
                      {notifications.map((itm, index) => (
                        <div key={index} className="notification-item ">
                          <span className="fs-16 text-white">
                            <span className="fw-semibold">{itm.title}</span>
                            <br />
                            <span className="">{itm.description}</span>
                          </span>
                          <div className="d-flex justify-content-between">
                            <span className="w-100 fs-12 text-white opacity-50">
                              {getReadableDate(itm.createdAt)}
                            </span>
                            <span
                              className="w-100 fs-12 text-purple cursor-pointer text-end"
                              onClick={() => {
                                handleMarkSeen(false, itm.userNotificationId);
                              }}
                            >
                              Mark as read
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {profileData ? (
                    <div className="app-navbar-item ms-md-3 align-self-center">
                      <div
                        className="cursor-pointer symbol symbol-30px symbol-md-40px"
                        // onMouseOver={() => {
                        //   setHoverProfile(true);
                        //   setHoverTheme(false);
                        // }}
                        onClick={() => {
                          setHoverProfile((prev) => !prev); // toggle on click
                          setHoverTheme(false);
                        }}
                      >
                        <span
                          className="svg-icon svg-icon-2 text-capitalize"
                          style={{
                            borderRadius: "50%",
                            width: "50px",
                            height: "40px",
                            padding: "7px 15px",
                            color: "white",
                            background: "var(--secondary-accent)",
                          }}
                        >
                          {profileData?.user?.name?.charAt(0)}
                        </span>
                        {/* <img
                        src={profileData?.user?.profile_pic || UserProfile}
                        className="svg-icon svg-icon-2"
                      /> */}
                      </div>

                      {hoverProfile && (
                        <div
                          className="menu menu-sub menu-sub-dropdown menu-gray-800 py-3 pb-2 mt-3 fs-6"
                          // onMouseOver={() => {
                          //   setHoverProfile(true);
                          // }}
                          // onMouseOut={() => {
                          //   setHoverProfile(false);
                          // }}
                          // onClick={(e) => {
                          //   e.nativeEvent.stopImmediatePropagation();
                          // }}
                          onClick={(e) => {
                            e.nativeEvent.stopImmediatePropagation();
                          }}
                          style={{ zIndex: 999 }}
                        >
                          <div className="menu-item px-3 cursor-none">
                            <div className="menu-content d-flex align-items-center ">
                              <div className="d-flex align-items-center mb-3 gap-2">
                                <div className="symbol symbol-50px me-1">
                                  <img
                                    src={
                                      profileData?.user?.profile_pic ||
                                      UserProfile
                                    }
                                    alt="User"
                                    className="rounded-circle object-fit-cover"
                                  />
                                </div>
                                <div className="menu-section">
                                  <div className="fw-bold">
                                    {profileData?.user?.username}
                                  </div>
                                  <div className="fs-12">
                                    {profileData?.user?.mobile}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {sideBarList.map((item, idx) => (
                            <div key={idx}>
                              <div className="separator my-1"></div>

                              <div
                                className={`menu-item px-2 py-1 mx-2 ${
                                  item.label === currentPage
                                    ? "active side-link"
                                    : ""
                                }`}
                                onClick={() => {
                                  handleSidebarClick(item);
                                }}
                              >
                                <span className="svg-icon svg-icon-2  ">
                                  {item.img}
                                </span>
                                <span className="menu-link fs-14 px-2">
                                  {t(`Sidebar.${item.name}`)}
                                </span>
                              </div>
                            </div>
                          ))}

                          <div className="separator my-1"></div>

                          <div
                            className="menu-item-logout px-2 py-1 mx-2"
                            onClick={() => {
                              console.log("signout");
                              handleSignout();
                            }}
                          >
                            <span className="svg-icon svg-icon-2  ">
                              <img
                                src={Logout}
                                alt="icon"
                                width={22}
                                height={22}
                                className="svg-icon"
                              />
                            </span>
                            <span className="menu-link fs-14 px-2">Logout</span>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      <div className="app-navbar-item ms-1 ms-md-3 align-self-center">
                        <span
                          className="box-purple text-white-btn fs-14 py-2 px-2 align-self-center cursor-pointer"
                          onClick={() => {
                            navigate("/signin-username");
                          }}
                        >
                          <img src={login} alt="icon" className="svg-icon" />{" "}
                          {t("SignUpPage.login")}
                        </span>
                      </div>
                      <div className="app-navbar-item ms-1 ms-md-3 align-self-center">
                        <span
                          className="box-purple text-white-btn  fs-14 py-2 px-2 align-self-center cursor-pointer"
                          onClick={() => {
                            navigate("/signup");
                          }}
                        >
                          <img src={Profile} alt="icon" className="svg-icon" />{" "}
                          {t("SignUpPage.signUp")}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </nav>
          {profileData?.user?.isDemoUser && (
            <h4 className="w-100 text-center text-white bg-purple">
              <span className="m-auto">Yor are logged in as a Demo user. </span>
            </h4>
          )}
          <hr className="m-0" />
        </div>
      </div>
    </div>
  );
};

HumburgerMenu.prototype = {
  menuOpen: PropTypes.bool,
  setMenuOpen: PropTypes.func,
};

export default HumburgerMenu;
